import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";
import SimpleMap from "../../../components/gmaps";
import Modal from "react-modal";
const CollectionCentersForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const { addForm, update } = props;
  const frmRef = useRef({});

  const [warehosuedata, setWarehosuedata] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [warehosuelatLong, setWarehosuelatLong] = useState({
    lat: "",
    lng: "",
  });
  const [latLongclose, setLatLongclose] = useState(false);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const handleLatLong = () => {
    setLatLongclose(true);
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          console.log("lat",lat,"long",lng);
          
          setWarehosuelatLong({ lat, lng });
        },
        (error) => {
          console.error("Location error:", error.message);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      console.error("Geolocation not supported");
    }
  }, []);

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem(
          "orgId"
        )}&&storeTypeId=1&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setWarehosuedata(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: postWarehouse } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      name: frmRef.current.warehouseName.value.trim(),
      code: frmRef.current.warehouseCode.value.trim(),
      SupervisorEmployeeId: frmRef.current.emp_id.value,
      address: frmRef.current.warehouse_address.value,
      store_type_id: 1,
      city: frmRef.current.city.value,
      state: frmRef.current.state.value,
      zipCode: frmRef.current.zipcode.value,
      country: frmRef.current.country.value,
      contactWork: frmRef.current.work_contact_number.value,
      whatsapp: frmRef.current.whatsapp.value,
      emailId: frmRef.current.email_id.value,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      created_by: parseInt(localStorage.getItem("id")),
      warehouseLatLong: warehosuelatLong,
      created_date: new Date(),
      serviceId: props.sId
    };

    // console.log(data);
    postWarehouse(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem(
          "orgId"
        )}&storeTypeId=1&createdBy=${localStorage.getItem("id")}`,

        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`Warehosue detail added`);
        props.addForm(false);
      }
    );
  };

  return (
    <>
      {latLongclose && (
        <Modal onClose={setLatLongclose} isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={warehosuelatLong.lat}
            lng={warehosuelatLong.lng}
            set={setWarehosuelatLong}
            close={setLatLongclose}
          />
        </Modal>
      )}{" "}
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Warehouse Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Warehouse Code</label>

                        <input
                          type="text"
                          className="form-control"
                          ref={(el) => (frmRef.current["warehouseCode"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Warehouse Name </label>

                        <input
                          type="text"
                          className="form-control"
                          ref={(el) => (frmRef.current["warehouseName"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Assigned Supervisor</label>
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            setEmployeeId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Employee</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option key={x.userId} value={x.userId}>
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>WarehouseAddress</label>

                        <input
                          type="text"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["warehouse_address"] = el)
                          }
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>City </label>
                        <input
                          type="text"
                          id="city"
                          className="form-control"
                          ref={(el) => (frmRef.current["city"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> State/Province/Region</label>
                        <input
                          type="text"
                          id="state"
                          className="form-control"
                          ref={(el) => (frmRef.current["state"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Country </label>
                        <input
                          type="text"
                          id="country"
                          className="form-control"
                          ref={(el) => (frmRef.current["country"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Zip Code (Postal Code) </label>
                        <input
                          type="text"
                          id="zip_code"
                          className="form-control"
                          ref={(el) => (frmRef.current["zipcode"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Lat/Long</label>
                        <br />
                        <button
                          type={"button"}
                          id={"billinglatLong"}
                          autoComplete="off"
                          onClick={(e) => {
                            handleLatLong(e);
                          }}
                          ref={(el) => (frmRef.current["billinglatLong"] = el)}
                          className="btn btn-sm btn-warning"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Contact Number(Work)</label>
                        <input
                          type="text"
                          id="work"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["work_contact_number"] = el)
                          }
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Contact Number(whatsapp)</label>
                        <input
                          type="text"
                          id="whatsapp"
                          className="form-control"
                          ref={(el) => (frmRef.current["whatsapp"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Email id</label>
                        <input
                          type="email"
                          id="email_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["email_id"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default CollectionCentersForm;
